// let threwMissingAssertionError = false;

export const DEFAULT_QUERY_OPTIONS = {
  staleTime: Infinity,
  retry: 2,
};
